"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KriptonioError = void 0;
const viem_1 = require("viem");
class KriptonioError extends Error {
    constructor(error) {
        super(error.message ?? undefined);
        this.code = error.code ?? undefined;
        if (error.cause) {
            this.cause =
                error.cause instanceof viem_1.BaseError
                    ? error.cause
                    : new KriptonioError(error.cause);
        }
    }
}
exports.KriptonioError = KriptonioError;
KriptonioError.fromJsonRpcError = (error) => {
    if (!error) {
        return null;
    }
    return new KriptonioError({
        code: error.code,
        message: error.message ?? undefined,
        cause: error.data?.cause
            ? KriptonioError.fromJsonRpcError(error.data.cause)
            : undefined,
    });
};
